import React, { ComponentType, useEffect } from 'react';
import { withInject } from '@piwikpro/platform';
import { RouterService, useAdministrationOverlay } from '@piwikpro/router-crate';
import { App } from '@piwikpro/apps-crate/model';
import FirstAppTrialComponent from '@piwikpro/apps-crate/components/FirstAppTrial/FirstAppTrial';
import { TrackerSettingsState } from '@piwikpro/tracker-settings-crate/redux/app';

interface AppCreatorProps {
  loggedUserEmail: string | undefined
  existingApp: App | null | undefined
  filters: any
  appTrackerSettings: TrackerSettingsState['settings']
  globalTrackerSettings: TrackerSettingsState['settings']
}

interface AppsListOverlayProps {
  AppCreator: ComponentType<AppCreatorProps>
  FirstAppTrial: typeof FirstAppTrialComponent
  routerService: RouterService
  appCreatorProps: AppCreatorProps
  firstAppTrialProps: {
    isLoading: boolean
    failed: boolean
    app: App | null | undefined
    apps: App[]
  }
}

/** List-level overlays; URL suffix via administrationOverlayRewrite. */
const AppsListOverlay: React.FC<AppsListOverlayProps> = ({
  AppCreator,
  FirstAppTrial,
  routerService,
  appCreatorProps,
  firstAppTrialProps,
}) => {
  const overlay = useAdministrationOverlay();

  // Legacy /m/create → /o/app-creator (CreateApp removed; always use AppCreator).
  useEffect(() => {
    if (overlay === '/m/create') {
      routerService.openAdministrationOverlay('/o/app-creator', { replace: true });
    }
  }, [overlay, routerService]);


  if (overlay === '/o/app-creator' || overlay === '/m/create') {
    return <AppCreator {...appCreatorProps} />;
  }

  if (overlay === '/o/first-app-trial' || overlay === '/o/first-app') {
    return (
      <FirstAppTrial
        isLoading={firstAppTrialProps.isLoading}
        failed={firstAppTrialProps.failed}
        app={firstAppTrialProps.app!}
        apps={firstAppTrialProps.apps}
      />
    );
  }

  return null;
};

export default withInject({
  routerService: 'RouterCrate.router',
})(AppsListOverlay);
